import { render, staticRenderFns } from "./Configuration_ProductysManager.vue?vue&type=template&id=58a693a6&"
import script from "./Configuration_ProductysManager.vue?vue&type=script&lang=js&"
export * from "./Configuration_ProductysManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports